import CustomerReview from './CustomerReview';

export default CustomerReview;